import React, { useEffect, useRef } from "react";
import GridLayer from "./grid-layer";
import * as d3 from 'd3';
import useEditorStore from "@/store/useEditorStore";
import NodeLayer from "./node-layer";
import LinkLayer from "./link-layer";
import EventLayer from "./event-layer";
import LassoLayer from "./lasso-layer";

const RustRedEditor = ({flow, onDbClick, space_width=8000,space_height=8000,gridSize = 20}) => {
    const init = useEditorStore.use.init();
    const chartRef = useRef(null);
    const outerRef = useRef(null);
    const eventLayerRef = useRef(null);
    const gridLayerRef = useRef(null);
    const groupLayerRef = useRef(null);
    const groupSelectLayerRef = useRef(null);
    const linkLayerRef = useRef(null);
    const dragGroupLayerRef = useRef(null);
    const junctionLayerRef = useRef(null);
    const nodeLayerRef = useRef(null);
    const divContainerRef = useRef(null);

    useEffect(()=>{
        if(chartRef.current){
            init(chartRef.current,
            outerRef.current,
            eventLayerRef.current,
            gridLayerRef.current,
            groupLayerRef.current,
            groupSelectLayerRef.current,
            linkLayerRef.current,
            dragGroupLayerRef.current,
            junctionLayerRef.current,
            nodeLayerRef.current,
            divContainerRef.current,
        );
        }
    },[]);

    //// 使用useEditorStore的generateLinks和nodes
    //const generateLinks = useEditorStore.use.generateLinks();
    //const nodes = useEditorStore.use.nodes();
    //// 监听nodes的变化，并执行generateLinks
    //useEffect(()=>{
    //  generateLinks();
    //},[nodes]);

    return (<div ref={chartRef} className="rust-red-workspace">
        <div onKeyDown={(e) => {
            // 检查是否是Delete键
            if (e.key === 46) {
                // 执行删除操作
                console.log('Delete key pressed');
                // 这里可以添加你的删除逻辑
            }
        }}
        style={{ 
            minWidth: "500px", 
            width: "100%",
            height: "calc(100vh - 8rem)",
            overflow: 'auto',
        }}
        ref={divContainerRef}
        >
            <svg ref={outerRef} width={space_width} height={space_height} pointerEvents={"all"} style={{cursor:"crosshair",touchAction:"none"}}>
                <EventLayer ref={eventLayerRef}>
                    <rect className="workspace-chart-background" fill={"#fff"}
                            width={space_width} height={space_height}></rect>
                    <GridLayer ref={gridLayerRef} width={space_width} size={gridSize} />
                    <g ref={groupLayerRef}></g>
                    <g ref={groupSelectLayerRef}></g>

                    <g ref={dragGroupLayerRef}></g>
                    <g ref={junctionLayerRef}></g>
                    <LinkLayer ref={linkLayerRef} width={space_width} height={space_height} />                    
                    <NodeLayer flow={flow} onDbClick={onDbClick} ref={nodeLayerRef} />
                    <LassoLayer />
                </EventLayer>
            </svg>
        </div>
    </div>);
}

export default RustRedEditor;